import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { User } from '@intellio/shared/models';
import { AccountFacade } from '@intellio/shared/state-mgmt';

@Directive({ selector: '[itcUserInternality]' })
export class UserInternalityDirective implements OnInit {
  @Input('itcUserInternality')
  isInternal: boolean;
  private currentUser: User;
  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private accountFacade: AccountFacade
  ) {
    this.accountFacade.currentUser$.subscribe((user) => {
      this.currentUser = user;
    });
  }

  ngOnInit() {
    this.viewContainer.clear();

    if (this.currentUser.isExternal === !this.isInternal) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
